/**
 * Supabase Client Configuration
 * Handles authentication and database connections
 */

import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || ''
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ''

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('⚠️ Supabase credentials not configured. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in .env')
} else {
  // Log Supabase URL for debugging (don't log full key)
  console.log('🔧 Frontend Supabase URL:', supabaseUrl)
  console.log('🔧 Frontend Supabase Anon Key:', supabaseAnonKey.substring(0, 30) + '...')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce', // More secure PKCE auth flow
    storageKey: 'audit-platform-auth',
  }
})

// Export for type safety (optional but recommended for TypeScript)
export type Database = {
  // Add your database types here if using TypeScript with Supabase CLI
  // Run: supabase gen types typescript --project-id your-project-ref > types/database.types.ts
}

